// Mock data for Faye — Créatrice UGC portfolio (frontend-only teaser)

export const profile = {
  name: "Faye",
  brand: "Faye Visuals",
  role: "Créatrice UGC & Community Manager",
  roleShort: "Créatrice UGC",
  location: "Strasbourg & Paris",
  email: "contact.fayevisuals@gmail.com",
  tagline: "Créer, c'est transformer une émotion en image, et une image en souvenir.",
  heroImage:
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/j2hukef9_IMG_1168.webp",
  aboutImage:
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/mki71d00_IMG_4311.webp",
  bio: [
    "Moi c'est Faye, créatrice UGC & community manager basée entre Strasbourg & Paris.",
    "Avec plus de 3 ans d'expérience en communication digitale, j'accompagne les marques dans leur stratégie de contenu et la gestion de leurs réseaux sociaux, pour créer une connexion authentique, naturelle et engageante avec leur audience.",
    "Mon objectif ? Mettre en valeur votre univers et renforcer la confiance de votre communauté à travers des vidéos et photos qui inspirent et convertissent.",
  ],
  socials: [
    { label: "Instagram", handle: "@faye_visuals", href: "https://www.instagram.com/faye_visuals?igsh=MXEyb3dqZjdkb2dlcA==" },
    { label: "TikTok", handle: "@shee.films", href: "https://www.tiktok.com/@shee.films?_r=1&_t=ZG-989is551jcG" },
    { label: "Email", handle: "contact.fayevisuals@gmail.com", href: "mailto:contact.fayevisuals@gmail.com" },
  ],
};

export const stats = [
  { value: "3+", label: "ans d'expérience" },
  { value: "20+", label: "marques accompagnées" },
  { value: "100%", label: "contenu authentique" },
];

export const projects = [
  {
    id: "shodai",
    category: "UGC",
    title: "Shodai Matcha",
    place: "Paris",
    instagram: "https://www.instagram.com/reel/DM0fnUNI4Au/?igsh=cWtmZWs1MzVlaTJk",
    videoUrl: "https://vm.tiktok.com/ZGd9cvcRA/",
    mission:
      "Shodai Matcha m'a contactée pour créer une vidéo UGC authentique mettant en avant leur univers japonais, leurs produits phares et l'expérience unique proposée à Bercy Village.",
    objectives: [
      "Valoriser les spécialités (chiffon cake au matcha, matcha lattés, takoyakis)",
      "Transmettre l'ambiance japonaise et zen du lieu",
      "Donner envie aux clients de vivre l'expérience Shodai",
    ],
    cover:
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/olu3wkgq_IMG_2748.jpeg",
    gallery: [
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/txz3meyf_IMG_2747.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/olu3wkgq_IMG_2748.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/aqr45uex_IMG_2746.jpeg",
    ],
  },
  {
    id: "kafkaf",
    category: "UGC",
    title: "Kafkaf Paris",
    place: "Paris",
    instagram: "https://www.instagram.com/reel/DNQqAT8oFxJ/?igsh=MWJ5NmlyNDFmaXptaw==",
    videoUrl: "https://vm.tiktok.com/ZGd9ccKJo/",
    mission:
      "Kafkaf Paris m'a confié la création d'une vidéo UGC immersive pour mettre en avant leur coffee shop au style marocain, leur brunch gourmand et leur spécialité matcha.",
    objectives: [
      "Valoriser l'ambiance chaleureuse et l'identité marocaine du lieu",
      "Mettre en avant les plats phares et le brunch complet",
      "Inspirer la communauté à découvrir un spot unique à Paris",
    ],
    cover:
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/695uvn9c_IMG_2738.jpeg",
    gallery: [
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/x516bu4t_IMG_2741.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/695uvn9c_IMG_2738.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/7amh5obs_IMG_2735.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/cea4vlll_IMG_2739.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/r0fmw47p_IMG_2736.jpeg",
    ],
  },
  {
    id: "sally",
    category: "UGC",
    title: "Sally Coiffure",
    place: "Strasbourg",
    instagram: "https://www.instagram.com/reel/DUBRLxQDQkO/?igsh=MW01Z3NvYnAxN3R2MA==",
    videoUrl: "https://vm.tiktok.com/ZGd93NgtV/",
    mission:
      "Sally Coiffure m'a confié la réalisation d'une vidéo UGC pour mettre en avant l'expérience client dans son salon, à travers un soin capillaire complet et une prestation de coloration.",
    objectives: [
      "Montrer le savoir-faire et la qualité des services proposés",
      "Mettre en avant l'ambiance chaleureuse et professionnelle du salon",
      "Inspirer confiance et donner envie aux clientes de réserver",
    ],
    cover:
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/h5a0u1rb_IMG_2780.jpeg",
    gallery: [
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/h5a0u1rb_IMG_2780.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/2zx9bac3_IMG_2784.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/3lpmmqp2_IMG_2785.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/yp93sxxq_IMG_2782.jpeg",
      "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/n8a6dzr6_IMG_2783.jpeg",
    ],
  },
];

export const weddings = {
  title: "Mariages & Émotions capturées",
  text: "Immortaliser les instants uniques d'une journée de mariage, c'est raconter une histoire d'amour à travers des images authentiques et intemporelles. Mon approche : capturer l'émotion, la spontanéité et les détails qui rendent chaque célébration inoubliable.",
  gallery: [
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/b5r3w6mp_IMG_1336.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/tppfy93k_IMG_4922.webp",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/mq4lc87p_IMG_1382.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/zehq64b6_IMG_4929.webp",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/e8zjyrq9_IMG_1320.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/7qciketn_IMG_1344.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/ejn7i8qp_IMG_4628.webp",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/xdbnkscn_IMG_1327.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/qkdk8keh_IMG_1318.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/gjb9p94k_IMG_4904.webp",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/em8s1vj1_IMG_1380.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/of58seet_IMG_1359.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/9ivb6qh8_IMG_1345.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/ewp5l0km_IMG_4908.webp",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/kktvtygo_IMG_1330.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/fjyok9jp_IMG_1321.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/4r083x93_IMG_4810.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/1r6vvkl6_IMG_1343.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/eqddjjha_IMG_1333.jpeg",
    "https://customer-assets-agu9un31.emergentagent.net/job_creative-gallery-236/artifacts/c21fjmx9_IMG_1332.jpeg",
  ],
};

export const skills = [
  { key: "organisee", title: "Organisée", icon: "ListChecks", text: "Je gère chaque projet avec méthode, du brief jusqu'à la livraison finale, pour garantir un contenu clair et structuré." },
  { key: "equipe", title: "Travail d'équipe", icon: "Users", text: "Je sais collaborer avec des vidéastes, photographes ou marques pour que chaque projet soit une réussite collective." },
  { key: "creative", title: "Créative", icon: "Sparkles", text: "Je transforme les idées en visuels impactants qui captent l'attention et suscitent l'émotion." },
  { key: "polyvalente", title: "Polyvalente", icon: "Layers", text: "Je travaille aussi bien sur des projets UGC, mariage, mode ou restauration, en m'adaptant à chaque univers." },
  { key: "curieuse", title: "Curieuse", icon: "Compass", text: "J'aime explorer de nouveaux concepts et m'inspirer de différentes tendances pour enrichir mes créations." },
  { key: "autonome", title: "Autonome", icon: "Rocket", text: "Habituée à gérer des projets de A à Z, je suis capable de produire un contenu de qualité en toute indépendance." },
  { key: "reactive", title: "Réactive", icon: "Zap", text: "Je m'adapte rapidement aux demandes et aux imprévus pour assurer une collaboration fluide." },
  { key: "ecoute", title: "À l'écoute", icon: "Heart", text: "Je prends le temps de comprendre les besoins de chaque client afin de créer un contenu qui reflète vraiment leur univers." },
];

export const brands = [
  "Shodai Matcha",
  "Kafkaf Paris",
  "Sally Coiffure",
  "Bercy Village",
];

export const services = [
  {
    key: "ugc",
    icon: "Video",
    title: "Vidéo UGC",
    text: "Des vidéos authentiques pensées pour les réseaux (TikTok, Reels, Shorts) qui mettent en scène vos produits et racontent votre marque.",
    tags: ["Script & concept", "Tournage", "Montage vertical"],
  },
  {
    key: "photo",
    icon: "Camera",
    title: "Photos & Visuels",
    text: "Des visuels lifestyle soignés pour vos réseaux, votre site ou vos campagnes, dans une esthétique chaleureuse et naturelle.",
    tags: ["Photos produits", "Lifestyle", "Retouche"],
  },
  {
    key: "ambassadrice",
    icon: "Star",
    title: "Ambassadrice de marque",
    text: "Un partenariat durable pour incarner votre marque et fédérer votre communauté autour de contenus réguliers et sincères.",
    tags: ["Partenariat", "Contenu régulier", "Communauté"],
  },
  {
    key: "mariage",
    icon: "Heart",
    title: "Mariages & Événements",
    text: "La captation émotionnelle de vos moments uniques, en photo et en vidéo, pour des souvenirs intemporels.",
    tags: ["Photo", "Vidéo", "Souvenirs"],
  },
];

export const process = [
  { step: "01", icon: "MessageCircle", title: "Brief & échange", text: "On définit ensemble vos objectifs, votre univers et le message à transmettre." },
  { step: "02", icon: "Lightbulb", title: "Concept & scénario", text: "Je conçois un concept créatif et un plan de tournage adaptés à votre marque." },
  { step: "03", icon: "Clapperboard", title: "Tournage", text: "Je capture un contenu authentique, naturel et esthétique, fidèle à votre identité." },
  { step: "04", icon: "PackageCheck", title: "Montage & livraison", text: "Je monte, retouche et vous livre un contenu prêt à publier sur vos réseaux." },
];

// Placeholder testimonials — à remplacer par de vrais avis clients
export const testimonials = [
  {
    name: "Léa M.",
    role: "Fondatrice · Coffee shop",
    text: "Faye a parfaitement capturé l'ambiance de notre lieu. La vidéo UGC a boosté notre visibilité et nos réservations !",
  },
  {
    name: "Marc D.",
    role: "Marque de bijoux",
    text: "Un contenu élégant, naturel et premium, exactement dans l'esprit de notre marque. Collaboration fluide et professionnelle.",
  },
  {
    name: "Sally",
    role: "Sally Coiffure · Strasbourg",
    text: "À l'écoute, créative et très réactive. Le résultat a dépassé nos attentes, je recommande les yeux fermés.",
  },
];

export const navLinks = [
  { label: "Accueil", href: "#accueil" },
  { label: "Projets", href: "#projets" },
  { label: "Services", href: "#services" },
  { label: "Mariages", href: "#mariages" },
  { label: "Profil", href: "#profil" },
  { label: "Contact", href: "#contact" },
];
